export default __webpack_public_path__ + "static/media/Beratoneicon.5de45e33.png";